<span class="px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider inline-flex items-center glass-panel"
    [ngClass]="severityClass()">
    {{ label() || severity() }}
</span>